import { gql } from '@apollo/client';

const UPDATE_LANGUAGE = gql`
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfileV2(input: $input) {
      personalInfo {
        language
      }
    }
  }
`;

export default UPDATE_LANGUAGE;
